import React, { useCallback, useEffect, useMemo, useState } from "react"
import RegularButton from "components/CustomButtons/Button";
import { Box, Typography, Grid, Autocomplete, TextField } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import {
  sendConfigUnitV2,
  resetTagsStation,
  sendUnitManualConf,
  sendVersionUnit,
  updateFlowmeter,
  updateMaintenanceStatus,
} from "redux/actions/unitsSection/unitsAction";
import { updateUnitConfigFillingOrder } from "../../redux/actions/carburetions/carburetionAction";
import LocalGasStationIcon from '@material-ui/icons/LocalGasStation';
import SettingsIcon from "@material-ui/icons/Settings";
import { useToggle } from "hooks/useToggle";
import EditIcon from '@mui/icons-material/Edit';
import { animations } from "helpers/animations";
import ModalConfig from "components/ModalConfig/ModalConfig";
import { ModalV2 } from "components/Modal/ModalV2";
import BusinessIcon from '@mui/icons-material/Business';
import { AddStationBrands } from "./AddStationBrands";
import LocalOfferIcon from '@mui/icons-material/LocalOffer';
import { AddUnitTags } from "./AddUnitTags";
import PortableWifiOffIcon from '@mui/icons-material/PortableWifiOff';
import WifiTetheringIcon from '@mui/icons-material/WifiTethering';
import LocalShippingIcon from "@mui/icons-material/LocalShipping";
import RvHookupIcon from "@mui/icons-material/RvHookup";
import { ConfigDispensers } from "./ConfigDispensers";
import { AddPipeCondition } from "./AddPipeCondition";
import { AddPlatformCondition } from "./AddPlatformCondition";
import SwapVerticalCircleIcon from '@mui/icons-material/SwapVerticalCircle';
import TransformIcon from '@mui/icons-material/Transform';
import { ModalUnitTransfer } from "./ModalUnitTransfer";
import { PERMISSIONS } from "router/permissions";
import { FormFlowmeterUpdate } from "./FormFlowmeterUpdate";
import { useForm } from "hooks/useForm";
import { cleanNumber } from "helpers/cleanNumbers";
import { Build, Nfc } from "@mui/icons-material";
import { AddNfc } from "./AddNfc";

import FenceIcon from '@mui/icons-material/Fence';
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import { validateObject } from "helpers/validateObject";
import { useRuleValidator } from "hooks/useRuleValidator";
import { ImeiModal } from "./ImeiModal";


const colors = {
  success: '#4caf50',
  error: '#f6685e',
  info: '#4092E5'
};

const buttonStyle = { width: 34, minWidth: 34 };

const {
  UNITS_IMEI,
  UNIT_VERSION,
  UNIT_MANUAL_CONF,
  UNIT_FLOWMETER_UPDATE,
  UNIT_SYNC,
  UNIT_DISPENSER,
  UNIT_CONST_CENTER,
  UNIT_TAGS,
  UNIT_CONFIG,
  UNIT_PIPE_CONDITIONS,
  UNIT_PLATFORM_CONDITIONS,
  UNIT_STATION_TRANSFER,
  UNIT_MAINTENANCE,
  UNIT_NFC_TAG,
  UNIT_GEOFENCING,
  UNITS_VISIBLE_FILLING_ORDER,
  UNITS_CATALOG_WHOLESALER_EDIT,
} = PERMISSIONS;

export const columns = [

  {
    Header: '# Unidad',
    accessor: 'number',
    filterable: true,
    filterMethod: (filter, row) => row.number.toLowerCase().includes(filter.value.toLowerCase())
  },

  {
    Header: 'U. Planta',
    accessor: 'uStation',
    filterable: true,
    filterMethod: (filter, row) => row.uStation.toLowerCase().includes(filter.value.toLowerCase())
  },
  {
    Header: 'U. Operativa',
    accessor: 'uOperative',
    filterable: true,
    filterMethod: (filter, row) => row.uOperative.toLowerCase().includes(filter.value.toLowerCase())
  },
  {
    Header: 'Marca',
    accessor: 'brand',
    filterable: true,
    filterMethod: (filter, row) => row.brand.toLowerCase().includes(filter.value.toLowerCase())
  },
  {
    Header: 'Tipo',
    accessor: 'unit_type',
    filterable: true,
    filterMethod: (filter, row) => row.unit_type.toLowerCase().includes(filter.value.toLowerCase())
  },
  {
    Header: 'IMEI',
    accessor: 'imei',
    filterable: true,
    filterMethod: (filter, row) => row.imei?.toLowerCase().includes(filter.value.toLowerCase()),
    Cell: ({ original }) => {
      const isIMEI = useRuleValidator(UNITS_IMEI);
      const [edit, setEdit] = useToggle();

      useEffect(() => {
        if (edit) setEdit();
      }, [original?.id]);

      return (
        <>
          <Box style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
            <Grid container>
              <Grid item xs={12} sm={8}>
                <Box
                  sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    height: '100%',
                    width: '100%',
                  }}
                >
                  <div>{original?.imei}</div>
                </Box>
              </Grid>
              <Grid item xs={12} sm={4}>
              {
                isIMEI &&
                <RegularButton justIcon round color="transparent" onClick={setEdit} tooltip="Editar IMEI">
                  <EditIcon style={{ color: colors.info }} />
                </RegularButton>
              }
              </Grid>
            </Grid>
          </Box>

            {
              isIMEI && edit && (
                <ImeiModal 
                 edit={edit}
                 setEdit={setEdit}
                 imeiCode={original?.imei || ""}
                 unitId={original?.id}
                />
              )
            }
        </>
      )
    }
  },
  {
    Header: 'CRE',
    accessor: 'creLicense',
    filterable: true,
    filterMethod: (filter, row) => row?.creLicense.toLowerCase().includes(filter.value.toLowerCase())
  
  },
  {
    Header: 'Versión',
    accessor: 'version.label',
    filterable: true,
    filterMethod: (filter, row) => row['version.label']?.toLowerCase().includes(filter.value.toLowerCase()),
    Cell: ({ original }) => {
      const dispatch = useDispatch();
      const { versions } = useSelector(({ unitsReducer }) => unitsReducer);
      const { version, id } = useMemo(() => original, [original]);
      const isUnitVersion = useRuleValidator(UNIT_VERSION);
      const value = useMemo(() => versions.find(v => v.id === version?.id) || null, [versions, version]);

      return (
        <>
          {
            isUnitVersion ? (
              <Box style={{ display: 'flex', justifyContent: 'center' }}>
                <Autocomplete
                  id="combo-box-demo"
                  value={value}
                  options={versions}
                  getOptionLabel={(option) => option.label ? option.label : option.name}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Selecciona una versión"
                      variant="outlined"
                      fullWidth
                      size="small"
                    />
                  )}
                  fullWidth
                  onChange={(e, v) => dispatch(sendVersionUnit(id, v?.id, v))}
                  noOptionsText={"No hay resultados"}
                />
              </Box>
            ) : (
              <span>{version?.label}</span>
            )
          }
        </>
      )
    }
  },
  {
    Header: 'Acciones',
    filterable: false,
    Cell: ({ original }) => {
      const dispatch = useDispatch();

      // Permisos
      const ruleSyncUnit = useRuleValidator(UNIT_SYNC);
      const ruleDispenser = useRuleValidator(UNIT_DISPENSER);
      const ruleCostCenter = useRuleValidator(UNIT_CONST_CENTER);
      const ruleTags = useRuleValidator(UNIT_TAGS);
      const ruleConfig = useRuleValidator(UNIT_CONFIG);
      const rulePipeConditions = useRuleValidator(UNIT_PIPE_CONDITIONS);
      const rulePlatformConditions = useRuleValidator(UNIT_PLATFORM_CONDITIONS);
      const isUnitManualConf = useRuleValidator(UNIT_MANUAL_CONF);
      const ruleStationTransfer = useRuleValidator(UNIT_STATION_TRANSFER);

      const updateFlowmeterRule = useRuleValidator(UNIT_FLOWMETER_UPDATE) &&
        (original.unit_type.includes("ESTACION") || original.unit_type === "MAYORISTA_E") &&
        !original?.dispensers;

      const ruleNfcTag = useRuleValidator(UNIT_NFC_TAG);
      const ruleMaintenance = useRuleValidator(UNIT_MAINTENANCE);
      const ruleGeofencing = useRuleValidator(UNIT_GEOFENCING);
      const ruleVisibleFillingOrder = useRuleValidator(UNITS_VISIBLE_FILLING_ORDER);


      // Estado
      const { isLoadingComp } = useSelector(({ search }) => search);
      const { configTypes } = useSelector(({ unitsReducer }) => unitsReducer);
      const [openConfig, handleOpenConfig] = useToggle();
      const [openModal, handleOpenModal] = useToggle();
      const [tagModal, handleTagModal] = useToggle();
      const [dispenserModal, handleDispenserModal] = useToggle();
      const [pipeConditionsModal, handlePipeConditionsModal] = useToggle();
      const [platformConditionsModal, handlePlatformConditionsModal] = useToggle();
      const [openStationTransfer, setOpenStationTransfer] = useToggle();
      const [openUpdateFlowmeter, setOpenUpdateFlowmeter] = useToggle();
      const [maintenanceOpen, setMaintenanceOpen] = useToggle();
      const [nfcModal, handleNfcModal] = useToggle();
      const [filteredConfigTypes, setFilteredConfigTypes] = useState([]);
      const {
        inputValues,
        handleNumberInputOnChange,
        handleNewValues
      } = useForm({
        flowmeter: "",
      });

      const { flowmeter } = inputValues;      
      const { sync, id, dispensers, unitManualConf, nfcTag, isMaintenance, number, conf } = original;
      const { freeSales, showFillingOrder = true } = validateObject(conf) ?
        conf : { freeSales: false, showFillingOrder: true };

      const handleSyncUnit = useCallback(() => {
        const form = {
          sync: !original.sync
        }
        dispatch(sendConfigUnitV2(id, form))
      }, [dispatch, id, original.sync])

      const handleSetUnitManualConf = useCallback(() => {
        dispatch(sendUnitManualConf(id, unitManualConf ? 0 : 1))
      }, [dispatch, id, unitManualConf])


      const sendConfig = useCallback((id, body) => {
        dispatch(sendConfigUnitV2(id, body));
      }, [dispatch])

      const handleCloseTagsModal = useCallback(() => {
        dispatch(resetTagsStation())
        handleTagModal()
      }, [dispatch, handleTagModal])

      const handleUpdateFlowmeter = useCallback(() => {
        dispatch(updateFlowmeter(id, "", { flowmeter: cleanNumber(flowmeter) }, setOpenUpdateFlowmeter));
      }, [dispatch, id, flowmeter, setOpenUpdateFlowmeter])

      const handleMaintenance = useCallback(() => {
        const form = {
          isMaintenance: !isMaintenance
        };
        dispatch(updateMaintenanceStatus(id, form, setMaintenanceOpen));
      }, [dispatch, id, isMaintenance, setMaintenanceOpen])

      const handleGeofencing = useCallback(() => {
        const body = {
          conf: { ...conf, freeSales: !freeSales }
        };
        sendConfig(id, body);
      }, [conf, freeSales, id, sendConfig])

      const handleFillingOrder = () => {
        const toggledShowFillingOrder = !showFillingOrder;
        const body = {
          conf: { ...conf, showFillingOrder: toggledShowFillingOrder }
        };
        // Actualizar unitConfigs del reducer de carburations para reflejar el cambio inmediatamente en la UI.
        const updateUnitConfig = () => {
          dispatch(updateUnitConfigFillingOrder({ id, showFillingOrder: toggledShowFillingOrder }));
        };
        dispatch(sendConfigUnitV2(id, body, false, false, "", updateUnitConfig));
      };

      useEffect(() => {
        setFilteredConfigTypes(configTypes.filter((config) => config.confType === "UNIT"));
      }, [configTypes]);

      return (
        <>
          { ruleSyncUnit &&
            <RegularButton style={buttonStyle} justIcon round color='transparent' onClick={handleSyncUnit} tooltip={sync ? 'Desactivar Unidad' : 'Sincronizar Unidad'}>
              {
                sync
                  ?
                  <WifiTetheringIcon fontSize="small" className={animations.fadeIn} style={{
                    color: colors.success
                  }} />

                  : <PortableWifiOffIcon fontSize="small" className={animations.fadeIn} style={{
                    color: colors.error
                  }} />
              }
            </RegularButton>
          }
          { ruleDispenser &&
            <RegularButton style={buttonStyle} justIcon round color='transparent' onClick={handleDispenserModal} tooltip="Dispensadores" disabled={dispensers === null ? true : false}>
              <LocalGasStationIcon fontSize="small" style={{
                color: original.dispensers ? colors.success : colors.error
              }} />
            </RegularButton>
          }
          { ruleCostCenter &&
            <RegularButton style={buttonStyle} justIcon round color='transparent' tooltip="Centro de costos" onClick={handleOpenModal}>
              <BusinessIcon fontSize="small" style={{ color: colors.info }} />
            </RegularButton>
          }
          { ruleTags &&
            <RegularButton style={buttonStyle} justIcon round color='transparent' tooltip="Etiquetas" onClick={handleTagModal}>
              <LocalOfferIcon fontSize="small" style={{ color: colors.info }} />
            </RegularButton>
          }
          { ruleConfig &&
            <RegularButton style={buttonStyle} justIcon round color='transparent' tooltip="Configuración" onClick={handleOpenConfig}>
              <SettingsIcon fontSize="small" style={{ color: colors.info }} />
            </RegularButton>
          }
          { rulePipeConditions &&
            <RegularButton style={buttonStyle} justIcon round color='transparent' tooltip="Condiciones de Pipa" onClick={handlePipeConditionsModal}>
              <LocalShippingIcon fontSize="small" style={{ color: colors.info }} />
            </RegularButton>
          }
          { rulePlatformConditions &&
            <RegularButton style={buttonStyle} justIcon round color='transparent' tooltip="Condiciones de Plataforma" onClick={handlePlatformConditionsModal}>
              <RvHookupIcon fontSize="small" style={{ color: colors.info }} />
            </RegularButton>
          }
          { ruleNfcTag &&
            <RegularButton
              size="sm"
              style={buttonStyle}
              justIcon
              round
              color='transparent'
              onClick={handleNfcModal}
              tooltip={nfcTag?.id ? 'Reasignar NFC' : 'Asignar NFC'}
              disabled={isMaintenance ? true : false}
            >
              <Nfc fontSize="small" style={{ color: nfcTag?.id ? colors.success : colors.info }} />
            </RegularButton>
          }
          {
            isUnitManualConf && (
              <RegularButton style={buttonStyle} justIcon round color='transparent'
                onClick={handleSetUnitManualConf}
                tooltip={`${unitManualConf ? 'Desactivar' : 'Activar'} Liquidación Manual`}
                disabled={isMaintenance ? true : false}
              >
                <SwapVerticalCircleIcon fontSize="small" style={{ color: unitManualConf ? colors.error : colors.info }} />
              </RegularButton>
            )
          }
          { ruleStationTransfer &&
            <RegularButton
              justIcon
              round
              color="transparent"
              size="sm"
              onClick={setOpenStationTransfer}
              tooltip="Transferir Unidad Operativa"
            >
              <TransformIcon style={{ color: colors.info }} />
            </RegularButton>
          }
          {
            updateFlowmeterRule &&
            <RegularButton
              justIcon
              round
              color="transparent"
              onClick={setOpenUpdateFlowmeter}
              tooltip="Actualizar cuenta litros"
              disabled={isMaintenance ? true : false}
            >
              {/* <PercentIcon style={{color: colors.info}}/> */}
              <Typography variant="caption" style={{ color: colors.info }}>
                LTS
              </Typography>
            </RegularButton>
          }
          { ruleGeofencing &&
            <RegularButton style={buttonStyle} justIcon round color='transparent'
              onClick={handleGeofencing}
              tooltip={freeSales ? 'Desactivar Geocercas' : 'Activar Geocercas'}
              disabled={!conf}
            >
              <FenceIcon fontSize="small" className={animations.fadeIn} style={{
                color: conf ?
                  freeSales ? colors.success : colors.error
                  :
                  colors.info
              }} />
            </RegularButton>
          }
          { ruleVisibleFillingOrder  &&
            <RegularButton style={buttonStyle} justIcon round color='transparent'
              onClick={handleFillingOrder}
              tooltip={`${!showFillingOrder ? 'Mostrar' : 'Ocultar'} orden de llenado`}
              disabled={!conf}
            >
              {
                !showFillingOrder ?
                  <VisibilityIcon fontSize="small" className={animations.fadeIn} style={{ color: colors.info }} />
                  :
                  <VisibilityOffIcon fontSize="small" className={animations.fadeIn} style={{ color: colors.info }} />
              }
            </RegularButton>
          }

          {/* Maintenance */}
          {
            ruleMaintenance && (
              <RegularButton
                size="sm"
                style={buttonStyle}
                justIcon round
                color='transparent'
                tooltip={isMaintenance ? 'En mantenimiento' : 'Funcionando'}
                onClick={setMaintenanceOpen}
                loading={isLoadingComp?.loadingUnitsActions}
              >
                <Build fontSize="small" style={{ color: `${isMaintenance ? colors.error : colors.success}` }} />
              </RegularButton>
            )
          }

          <ModalConfig
            isOpen={openConfig}
            item={original}
            onCloseModal={handleOpenConfig}
            config={filteredConfigTypes}
            onSubmit={sendConfig}
            title="Configuración "
          />
          <ModalV2
            open={openModal}
            onClose={handleOpenModal}
            title="Centro de costos"
            toRight
          >
            <AddStationBrands data={original} onClose={handleOpenModal} />
          </ModalV2>
          <ModalV2
            open={tagModal}
            onClose={handleCloseTagsModal}
            title="Etiquetas"
            toRight
          >
            <AddUnitTags data={original} onClose={handleCloseTagsModal} />
          </ModalV2>
          <ModalV2
            open={dispenserModal}
            onClose={handleDispenserModal}
            title="Dispensadores"
            toRight
          >
            <ConfigDispensers data={original} onClose={handleDispenserModal} />
          </ModalV2>
          <ModalV2
            open={pipeConditionsModal}
            onClose={handlePipeConditionsModal}
            title={`Condiciones de Pipa`}
            toRight
          >
            <AddPipeCondition data={original} onClose={handlePipeConditionsModal} />
          </ModalV2>

          <ModalV2
            open={platformConditionsModal}
            onClose={handlePlatformConditionsModal}
            title={`Condiciones de Plataforma`}
            toRight
          >
            <AddPlatformCondition data={original} onClose={handlePlatformConditionsModal} />
          </ModalV2>
          <ModalUnitTransfer open={openStationTransfer} onClose={setOpenStationTransfer} original={original} />
          <ModalV2
            title="Actualizar cuenta litros"
            open={openUpdateFlowmeter}
            onClose={setOpenUpdateFlowmeter}
            justConfirm
            onSubmit={handleUpdateFlowmeter}
            isLoading={isLoadingComp?.loadingUpdateFlowmeter}
          >
            <FormFlowmeterUpdate
              values={{
                flowmeter, handleNumberInputOnChange, handleNewValues
              }}
            />
          </ModalV2>
          <ModalV2
            open={nfcModal}
            onClose={handleNfcModal}
            title="ASIGNACIÓN DE NFC TAG"
            justConfirm
          >
            <AddNfc data={original} onClose={handleNfcModal} />
          </ModalV2>
          <ModalV2
            open={maintenanceOpen}
            onClose={setMaintenanceOpen}
            title={`¿Estas seguro ${number}  ${isMaintenance ? 'de activar la unidad' : 'de mandar a mantenimiento la unidad'}?`}
            justConfirm
            onSubmit={handleMaintenance}
            isLoading={isLoadingComp?.loadingUnitsActions}
          />
        </>
      )
    }
  },
]